import { Component, Input } from '@angular/core';

@Component({
  selector: 'gains-title',
  templateUrl: './gains-title.component.html',
  styleUrl: './gains-title.component.scss',
  standalone: false
})
export class GainsTitleComponent {
  @Input() title = '';
}
